import OxiaClient from '@oxia/client';

import { defineNuxtPlugin } from '#app';

const config = {
  baseUrl: import.meta.env.VITE_APP_BASE_URL,
  defaultTheme: import.meta.env.VITE_APP_DEFAULT_THEME
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(OxiaClient, { config });
});
